<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-06-01 08:44:37
    Description : 
  -->
  <div class="gaia-card" @click="$emit('click')">
    <div
      class="cover"
      :style="{
        background: `url(${baseUrl + data.cover}) `,
        backgroundSize: '100% 100%',
      }"
    ></div>
    <good-one
      :theme="like ? 'filled' : 'outline'"
      size="40"
      fill="#ffa100"
      style="cursor: pointer"
      @click="worksAgree(data.id)"
    />
    <div class="votes">投票 ({{ data.likeCount }})</div>
    <div class="title">{{ data.title }}</div>
    <div class="number">No. {{ data.number }}</div>
  </div>
</template>

<script>
import { worksAgree } from "@/api/newgaia48";
import { GoodOne } from "@icon-park/vue";
export default {
  components: {
    GoodOne,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      like: false,
    };
  },
  created() {
    this.like = this.data.like;
  },
  methods: {
    worksAgree() {
      worksAgree(this.data.id).then((res) => {
        if (res.msg.includes("cancel")) {
          this.$message.success("取消点赞成功");
          this.like = false;
        } else {
          this.$message.success("点赞成功");
          this.like = true;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.gaia-card {
  display: inline-block;
  width: 300px;
  height: 620px;
  margin-right: 150px;
  text-align: center;
  .cover {
    width: 100%;
    height: 420px;
    margin-bottom: 10px;
    border: 4px solid #3f3f3f;
    background: #000000;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    font-size: 28px;
    font-weight: 400;
    color: #000000;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; //溢出不换行
  }
  .votes {
    font-size: 14px;
    color: gray;
  }
  .number {
    font-size: 20px;
    color: #000;
  }
}
</style>